import paymentMethod from './payment-method';
import standard from './standard';

export default {
  'payment-method': paymentMethod,
  'cancel-reason-code': standard(<i className="icon fa-light fa-ban" />),
  'unloading-method': standard(<i className="icon fa-light fa-ban" />),
};
